import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import ZGrid from '../components/ZGrid';
import { withStyles } from '@material-ui/core/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import success from '../asset/images/e320ee1fbb7df4136b9c1e745dbc62aa.png';
import failed from '../asset/images/e320ee1fbb7df4136b9c1e745dbc62aaa.png';
import { useHistory } from "react-router-dom";
import ZButton from '../components/ZButton';
import ZNav from '../components/ZNav';
import { toIndianRupee } from '../utils/common_function/common_function';
import label from '../utils/constants/label';

const drawerWidth = 240;

function Transaction(props) {
  const classes = props.classes
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [fromaccountNo, setFromaccountNo] = useState('NA');
  const [accountNo, setAccountNo] = useState('NA');
  const [amount, setAmount] = useState('NA');
  const [date, setNewDate] = useState('');
  const isMenuOpen = Boolean(anchorEl);
  let history = useHistory();

  const handleClickDone = () => {
    history.push("/dashboard")
  }

  const handleClickTryAgain = () => {
    history.push("/fundtransfer")
  }

  useEffect(() => {

    var today = new Date();
    var date = String(today.toDateString());
    var time = String(today.toLocaleTimeString());
    today = date + ', ' + time;

    setNewDate(today);
    let value = props.allData
    if (value != undefined && value != "") {
      setAccountNo(value.toAcc);
      setAmount(value.amount);
      setFromaccountNo(value.fromAcc);
    }
  }, [props.value]);

  return (
    <Box>
      <ZGrid container>
        <ZGrid item md={6} style={{ margin: "auto" }}>
          <Card className={classes.profileCard}>
            <CardContent className={classes.successCard}>
              <div>
                <img src={props.status == label.flag.success ? success : failed} height={230} />
              </div>
              <h4 className={classes.successHeader}>{props.status == label.flag.success ? label.messages.transferMsgSuccess : label.messages.transferMsgFailure}</h4>
              <div className={classes.cardSubHeader} style={{ padding: 0 }}>
                Transfer Details</div>
              <ZGrid container className={classes.summary}>
                <ZGrid item xs={6}>
                  From
                </ZGrid>
                <ZGrid item xs={6}>Savings - {fromaccountNo}</ZGrid>

                <ZGrid item xs={6}>
                  To
                </ZGrid>
                <ZGrid item xs={6}>Nikilesh, Axis Bank, Savings Account, {accountNo} </ZGrid>

                <ZGrid item xs={6}>
                  Amount (USD)
                </ZGrid>
                <ZGrid item xs={6}>(&#36;) {amount}</ZGrid>

                <ZGrid item xs={6}>
                  Date
                </ZGrid>
                <ZGrid item xs={6}>{date}</ZGrid>
              </ZGrid>

              <ZGrid item xs={12} md={12} className={classes.actionButton}>
                <div className={classes.dflex}>
                  {props.status == label.flag.success ?
                    <div onClick={() => { props.handleClickTryAgain() }}>
                      <ZButton variant="contained"
                        color="primary" name="Try Another Transaction" className={classes.btnLogin} ></ZButton>
                    </div>
                    :
                    <div onClick={() => { props.handleClickTryAgain() }}>
                      <ZButton variant="contained"
                        color="primary" name="Try Again" className={classes.btnLogin} ></ZButton>
                    </div>}
                </div>
              </ZGrid>
            </CardContent>
          </Card>
        </ZGrid>
      </ZGrid>
    </Box>
  );
}

const styles = (theme) => ({
  appBar: {
    position: "fixed",
    zIndex: theme.zIndex.drawer + 100,
    // backgroundColor: "#fff",
    backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
    // boxShadow:'none'
    boxShadow: '0px 0px 0px 0.5px rgb(0 0 0 / 9%)',
    backgroundImage: "linear-gradient( 310deg, #141727 0%, #3A416F 100%)",
    margin: "0px !important",
    '& .MuiToolbar-root': {
      padding: 0,
      minHeight: 90
    }
  },

  successCard: {
    '& div': {
      display: "flex",
      '& img': {
        margin: "auto"
      }
    }
  },

  actionButton: { display: "flex", justifyContent: "center" },

  dflex: {
    display: "flex",
    '& .MuiButton-root': {
      marginTop: "12px !important"
    }
  },
  GridContainer: {
    minHeight: 90
  },

  payFromMenu: {
    color: "rgba(0, 0, 0, 0.87) !important",
    fontFamily: "Noto Sans  !important",
  },

  summary: {
    color: "#212529", fontFamily: "Noto Sans  !important",
    '& .MuiGrid-item': {
      padding: "10px 0px"
    }

  },

  formControl: {
    width: "86%",
    margin: "4px !important",
    '& .MuiInputLabel-root': {
      color: "#9B9B9B",
      padding: 0, fontFamily: "Noto Sans ",
      lineHeight: 1,
    },

    '& .MuiFormControl-root': {
      width: "86%",
    },

    '& .MuiSelect-select': {
      fontFamily: "Noto Sans ",
    },

    '& .MuiFormHelperText-root': {
      color: "#f1416c"
    }
  },

  miriID: {
    width: "100%",
    margin: "0px 0px 20px 0px !important",

    '& label.MuiInputLabel-root': {
      color: "#9B9B9B",
      padding: 0, fontFamily: "Noto Sans ",
      lineHeight: 1,

    },

    '& input.MuiInputBase-input': {
      color: "rgba(0, 0, 0, 0.87)",
      fontFamily: "Noto Sans ",
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
        marginRight: 40,
      }
    },

    '& label.MuiInputLabel-root.Mui-focused': {
      color: "#303778"
    },

    '& div.MuiInput-root:after': {
      borderBottom: "2px solid #303778"
    }
  },

  textField: {
    // display: "flex",
    // alignItems: "center",
    //  justifyContent: "center",
    // flexWrap:"wrap"
  },

  iconTransaction: {
    '& .MuiSvgIcon-root': {
      transform: "rotate(45deg)",
      color: "#f1416c"
    }
  },

  account: { fontSize: "1.25rem", color: "#212529" },

  balance: { color: "#212529", paddingTop: 15, fontSize: "1.15rem", fontWeight: 600 },

  userWelcome: {
    display: "flex",
    alignItems: "center",
    marginLeft: 10,
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#212529"
  },

  cardHeader: {
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#212529",
    marginBottom: 20
  },

  successHeader: {
    fontWeight: 600,
    fontSize: 22,
    marginBottom: 20,
    marginTop: -20,
    color: "#92278F",
    fontFamily: 'Josefin Sans',
  },

  cardSubHeader: {
    color: "#212529",
    fontSize: 20,
    padding: "20px 0px 10px 0px",
    fontWeight: 600,
    fontFamily: 'Josefin Sans',
  },

  cardContent: { minHeight: 60 },

  avatar: {
    justifyContent: "flex-end",
    display: "flex",
    marginRight: 15
  },

  profileCard: {
    width: "100%",
    boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%) !important",
    borderRadius: "0.75rem !important",
    margin: "auto"
  },

  listItemIcon: {
    '& .MuiSvgIcon-root': {
      width: "1.5em",
      display: "flex",
      alignItems: "center",
      height: "1.5em",
      fill: "#303778",
      background: "#92278F",
      fill: "#fff",
      borderRadius: "0.5rem",
      padding: 5,
      boxShadow: "0 0.25rem 0.375rem -0.0625rem rgb(20 20 20 / 12%), 0 0.125rem 0.25rem -0.0625rem rgb(20 20 20 / 7%) !important"
    }
  },

  listItemText: {
    '&:hover': {
      '& span.MuiTypography-root': {
        fontWeight: 600,
      }
    },

    '& span.MuiTypography-root': {
      color: "#92278F",
      fontWeight: 400,
      fontFamily: 'Noto Sans '
    }
  },

  listItem: {
    paddingRight: 0,
    '&:hover': {
      paddingRight: 0,
      borderRadius: "0.75rem",
      background: "#FFF8FF",

      '& div.listItemText': {
        '& span.MuiTypography-root': {
          fontWeight: 600,
        }
      },

      '& listItemIcon': {
        '& svg.MuiSvgIcon-root': {
          background: "#303778",
          fill: "#fff",
          borderRadius: "0.5rem",
          padding: 5,
        }
      }
    },
  },

  menuContent: {
    '& .MuiToolbar-root': {
      minHeight: 90
    },

    '& .MuiPaper-root': {
      borderRight: "none",
      // background:"#f8f9fa !important"
    }
  },

  rightContent: {
    '& .MuiToolbar-root': {
      minHeight: 90
    }
  },

  logo: {
    margin: "20px !important",
    margin: "0px !important"
  },

  logoContainer: {
    background: "#fff", margin: 15, display: "flex",
    alignItems: "center",
    padding: "0px 10px"
  },


  txtWelcome: {
    fontWeight: 600,
    fontSize: 16,
    margin: 15,
    textTransform: "uppercase",
    fontFamily: "Noto Sans ",
    color: "#000000"
  },
})

export default withStyles(styles)(Transaction);